document.querySelectorAll('[data-password-toggle]').forEach((toggle) => {
  const input = document.getElementById(
    toggle.getAttribute('data-password-toggle')
  );

  if (!input) {
    return;
  }

  toggle.addEventListener('change', () => {
    input.type = toggle.checked ? 'text' : 'password';
  });
});
